// @flow
import map from 'ramda/es/map';
import toString from 'ramda/es/toString';

import type { Params, FinalMarks } from 'app/dataTypes/FinalMarks.types';

import type { Request } from '../../../index';


const dateFormatApi: 'YYYY-MM-DD' = 'YYYY-MM-DD';

type ParamsApi = {
  klass_id: number,
  student_id: number,
  date: string,
}

type ResultApi = {
  [discipline_id: string]: number,
  result: 'success',
}

export const convertParams = (params: Params): [ParamsApi, null] => {
  const { studentId, klassId, date } = params;

  return [{
    student_id: parseInt(studentId, 10),
    klass_id: parseInt(klassId, 10),
    date: date.getString(dateFormatApi),
  }, null];
};

export const convertResult = (res: ResultApi): FinalMarks => {
  const { result, ...marks } = res;
  const marksFinal = map(toString, marks);
  return marksFinal;
};

export const GET_GRADES_FINAL: Request<
  Params,
  FinalMarks,
  void
> = [
  'cabinet/dnevnik/grades/final',
  'get',
  ['data'],
];
